import { render } from "./LoadingScreenComponent.vue?vue&type=template&id=f0d0dcda&scoped=true"
import script from "./LoadingScreenComponent.vue?vue&type=script&lang=js"
export * from "./LoadingScreenComponent.vue?vue&type=script&lang=js"

import "./LoadingScreenComponent.vue?vue&type=style&index=0&id=f0d0dcda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d0dcda"]])

export default __exports__